module.exports = __webpack_public_path__ + "img/ava_carregamento_branco_100px.87052384.gif";